
import glovesIcon from "../../assets/images/icons/gloves.svg";
import worldIcon from "../../assets/images/icons/world.svg";
import deliveryIcon from "../../assets/images/icons/delivery.svg";
import warehouseIcon from "../../assets/images/icons/warehouse.svg";

const iconBoxesData = [
  {
    icon: glovesIcon,
    imageAlt: "gloves",
    title: "perfectly matched products",
  }, {
    icon: deliveryIcon,
    imageAlt: "delivery",
    title: "short delivery time",
  }, {
    icon: worldIcon,
    imageAlt: "world",
    title: "international cooperation",
  }, {
    icon: warehouseIcon,
    imageAlt: "warehouse",
    title: "modern logistic center",
  },
];

export { iconBoxesData };